/** @jsx jsx */
import PageLayout from "../../../../templates/Page";

export default PageLayout;
